// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.blocked-by-availability[data-v-c1eb7470] {\n  padding: 30px 90px;\n  background-color: #fff5d1;\n  color: #f93;\n  line-height: 1.64;\n}\n@media (max-width: 768px) {\n.blocked-by-availability[data-v-c1eb7470] {\n    padding: 20px 15px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
